import * as React from "react";
const SvgDownChevronIcon = (props) => /* @__PURE__ */ React.createElement("svg", { id: "a", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 100 100", ...props }, /* @__PURE__ */ React.createElement("polygon", { points: "50.14 81.6 100 31.74 86.73 18.47 50 55.19 13.27 18.47 0 31.74 49.86 81.6 50 81.46 50.14 81.6" }));
export default SvgDownChevronIcon;
